import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";

const api = new AxiosInterceptor();

export default {
  find(id) {
    return api.get("/delivery_slots/" + id);
  },
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get("/delivery_slots?" + qstr);
  },
  delete(id) {
    return api.delete("/delivery_slots/" + id);
  },
  create(inputs) {
    return api.post("/delivery_slots", inputs);
  },
  saveMaxSlot(inputs) {
    return api.post("/delivery_slots/save-max-slot", { content: inputs });
  },
  saveMinDay(inputs) {
    return api.post("/delivery_slots/save-min-days", { content: inputs });
  },
  enableSunday(inputs) {
    return api.post("/delivery_slots/enable-sunday", { status: inputs });
  },
  update(id, inputs) {
    return api.put("/delivery_slots/" + id, inputs);
  },
  getByMonth(qstr = {}) {
    let date = qstr.date;

    if (date) {
      let param = date.split("-");
      qstr.month = param[1];
      qstr.year = param[0];
    }

    qstr = fx.urlQueryString(qstr, false);
    return api.get("/delivery_slots/get-by-month?" + qstr);
  },
  getSettings() {
    return api.get("/delivery_slots/settings");
  },

  getRangeByOrder($order) {
    return api.get("/delivery_slots/range?order_id=" + $order);
  },
  getDeliveryCharging() {
    return api.get("/delivery_slots/get-delivery-fee");
  },
  updateDeliveryCharging(data) {
    return api.put("/delivery_slots/update-delivery-fee", data);
  },
};
